import { I } from '@angular/cdk/a11y-module.d-DBHGyKoh';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class PrimaryButtonComponent implements OnInit {
  @Input() label: string = 'Submit';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() customClass: string = '';
  @Input() color: string = '';
  @Input() ionIconName: string = '';
  @Input() iconOrder: 'left' | 'right' = 'left';
  @Output() clicked = new EventEmitter<void>();


  constructor() { }


  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }


  ngOnInit() { }

}
